<template>
  <div class="preliminary-feasibility-tab">
    <div class="tab-header">
      <h2>Preliminary Feasibility</h2>
      <p class="tab-description">
        Technical and economic viability assessment
      </p>
    </div>

    <form @submit.prevent="validateAndSubmit" class="project-form">
      
      <!-- Technical Prefeasibility -->
      <section class="form-section">
        <div class="section-header">
          <h3>Section A: Technical Prefeasibility</h3>
          <span class="section-description">(Optional)</span>
        </div>
        
        <div class="form-grid">
          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">1.Is the project likely to be based on technology that has been proven commercially in similar environments previously?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.provenTechnology" 
                    value="yes"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Yes
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.provenTechnology" 
                    value="no"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  No
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.provenTechnology" 
                    value="uncertain"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Uncertain
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.provenTechnology" 
                    value="skip"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Skip
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.provenTechnology" 
                    value="na"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="provenTechnologyComments">Comments</label>
            <textarea 
              id="provenTechnologyComments"
              v-model="formData.provenTechnologyComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              :disabled="viewMode"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">2.Is the project's scope of work comparable to other reference projects?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.comparableScope" 
                    value="yes"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Yes
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.comparableScope" 
                    value="no"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  No
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.comparableScope" 
                    value="uncertain"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Uncertain
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.comparableScope" 
                    value="skip"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Skip
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.comparableScope" 
                    value="na"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="comparableScopeComments">Comments</label>
            <textarea 
              id="comparableScopeComments"
              v-model="formData.comparableScopeComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              :disabled="viewMode"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">3.Are the technical cost estimates in line with required output specifications?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.costEstimates" 
                    value="yes"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Yes
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.costEstimates" 
                    value="no"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  No
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.costEstimates" 
                    value="uncertain"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Uncertain
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.costEstimates" 
                    value="skip"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Skip
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.costEstimates" 
                    value="na"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="costEstimatesComments">Comments</label>
            <textarea 
              id="costEstimatesComments"
              v-model="formData.costEstimatesComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              :disabled="viewMode"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">4.Are the life cycle costs for major components of the project reasonable and affordable?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.lifeCycleCosts" 
                    value="yes"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Yes
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.lifeCycleCosts" 
                    value="no"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  No
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.lifeCycleCosts" 
                    value="uncertain"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Uncertain
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.lifeCycleCosts" 
                    value="skip"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  Skip
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.lifeCycleCosts" 
                    value="na"
                    :disabled="viewMode"
                    @change="updateData"
                  />
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="lifeCycleCostsComments">Comments</label>
            <textarea 
              id="lifeCycleCostsComments"
              v-model="formData.lifeCycleCostsComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              :disabled="viewMode"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">5.Has a site suitability assessment been completed for the proposed project site?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.siteSuitability" 
                    value="yes"
                    @change="updateData"
                  />
                  Yes
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.siteSuitability" 
                    value="no"
                    @change="updateData"
                  />
                  No
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.siteSuitability" 
                    value="uncertain"
                    @change="updateData"
                  />
                  Uncertain
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.siteSuitability" 
                    value="skip"
                    @change="updateData"
                  />
                  Skip
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.siteSuitability" 
                    value="na"
                    @change="updateData"
                  />
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="siteSuitabilityComments">Comments</label>
            <textarea 
              id="siteSuitabilityComments"
              v-model="formData.siteSuitabilityComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">6.Is the proposed site accessible with any potential challenges during construction being manageable?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.siteAccessibility" 
                    value="yes"
                    @change="updateData"
                  />
                  Yes
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.siteAccessibility" 
                    value="no"
                    @change="updateData"
                  />
                  No
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.siteAccessibility" 
                    value="uncertain"
                    @change="updateData"
                  />
                  Uncertain
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.siteAccessibility" 
                    value="skip"
                    @change="updateData"
                  />
                  Skip
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.siteAccessibility" 
                    value="na"
                    @change="updateData"
                  />
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="siteAccessibilityComments">Comments</label>
            <textarea 
              id="siteAccessibilityComments"
              v-model="formData.siteAccessibilityComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">7.Will 'specific' technical skills and capabilities required for project implementation be available for this project and can be sourced either locally, regionally or globally? Construction, Operations and Maintenance?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.technicalSkills" 
                    value="yes"
                    @change="updateData"
                  />
                  Yes
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.technicalSkills" 
                    value="no"
                    @change="updateData"
                  />
                  No
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.technicalSkills" 
                    value="uncertain"
                    @change="updateData"
                  />
                  Uncertain
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.technicalSkills" 
                    value="skip"
                    @change="updateData"
                  />
                  Skip
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.technicalSkills" 
                    value="na"
                    @change="updateData"
                  />
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="technicalSkillsComments">Comments</label>
            <textarea 
              id="technicalSkillsComments"
              v-model="formData.technicalSkillsComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>
        </div>
        
     
      </section>

      <!-- Environmental Sustainability -->
      <section class="form-section">
        <div class="section-header">
          <h3>Section B: Environmental Sustainability</h3>
          <span class="section-description">(Optional)</span>
        </div>
        
        <div class="form-grid">
          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">1.Is there a reliable initial environmental analysis related to the project?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.environmentalAnalysis" 
                    value="yes"
                    @change="updateData"
                  />
                  Yes
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.environmentalAnalysis" 
                    value="no"
                    @change="updateData"
                  />
                  No
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.environmentalAnalysis" 
                    value="uncertain"
                    @change="updateData"
                  />
                  Uncertain
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.environmentalAnalysis" 
                    value="skip"
                    @change="updateData"
                  />
                  Skip
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.environmentalAnalysis" 
                    value="na"
                    @change="updateData"
                  />
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="environmentalAnalysisComments">Comments</label>
            <textarea 
              id="environmentalAnalysisComments"
              v-model="formData.environmentalAnalysisComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">2.Will the project have any significant negative impact on any natural resources or protected land?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.environmentalImpact" 
                    value="yes"
                    @change="updateData"
                  />
                  Yes
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.environmentalImpact" 
                    value="no"
                    @change="updateData"
                  />
                  No
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.environmentalImpact" 
                    value="uncertain"
                    @change="updateData"
                  />
                  Uncertain
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.environmentalImpact" 
                    value="skip"
                    @change="updateData"
                  />
                  Skip
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.environmentalImpact" 
                    value="na"
                    @change="updateData"
                  />
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="environmentalImpactComments">Comments</label>
            <textarea 
              id="environmentalImpactComments"
              v-model="formData.environmentalImpactComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">3.Is the identified environmental management strategy, or its related approvals, likely to result in uncertainties or delays that could impede the implementation of the project?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.environmentalManagement" 
                    value="yes"
                    @change="updateData"
                  />
                  Yes
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.environmentalManagement" 
                    value="no"
                    @change="updateData"
                  />
                  No
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.environmentalManagement" 
                    value="uncertain"
                    @change="updateData"
                  />
                  Uncertain
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.environmentalManagement" 
                    value="skip"
                    @change="updateData"
                  />
                  Skip
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.environmentalManagement" 
                    value="na"
                    @change="updateData"
                  />
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="environmentalManagementComments">Comments</label>
            <textarea 
              id="environmentalManagementComments"
              v-model="formData.environmentalManagementComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>
        </div>
      </section>

      <!-- Social Sustainability -->
      <section class="form-section">
        <div class="section-header">
          <h3>Section C: Social Sustainability</h3>
          <span class="section-description">(Optional)</span>
        </div>
        
        <div class="form-grid">
          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">1.Is there a reliable initial social analysis related to the project?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.socialAnalysis" 
                    value="yes"
                    @change="updateData"
                  />
                  Yes
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.socialAnalysis" 
                    value="no"
                    @change="updateData"
                  />
                  No
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.socialAnalysis" 
                    value="uncertain"
                    @change="updateData"
                  />
                  Uncertain
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.socialAnalysis" 
                    value="skip"
                    @change="updateData"
                  />
                  Skip
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.socialAnalysis" 
                    value="na"
                    @change="updateData"
                  />
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="socialAnalysisComments">Comments</label>
            <textarea 
              id="socialAnalysisComments"
              v-model="formData.socialAnalysisComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">2.Will the project have a significant adverse impact on the health or quality of life of users, workers, or the local population?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.socialImpact" 
                    value="yes"
                    @change="updateData"
                  />
                  Yes
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.socialImpact" 
                    value="no"
                    @change="updateData"
                  />
                  No
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.socialImpact" 
                    value="uncertain"
                    @change="updateData"
                  />
                  Uncertain
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.socialImpact" 
                    value="skip"
                    @change="updateData"
                  />
                  Skip
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.socialImpact" 
                    value="na"
                    @change="updateData"
                  />
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="socialImpactComments">Comments</label>
            <textarea 
              id="socialImpactComments"
              v-model="formData.socialImpactComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">3.Is the project likely to be socially sustainable or have manageable social impacts?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.socialSustainability" 
                    value="yes"
                    @change="updateData"
                  />
                  Yes
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.socialSustainability" 
                    value="no"
                    @change="updateData"
                  />
                  No
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.socialSustainability" 
                    value="uncertain"
                    @change="updateData"
                  />
                  Uncertain
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.socialSustainability" 
                    value="skip"
                    @change="updateData"
                  />
                  Skip
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.socialSustainability" 
                    value="na"
                    @change="updateData"
                  />
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="socialSustainabilityComments">Comments</label>
            <textarea 
              id="socialSustainabilityComments"
              v-model="formData.socialSustainabilityComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">4.Will the identified social management strategy, or its related approvals, result in uncertainties or delays that could impede project implementation?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.socialManagement" 
                    value="yes"
                    @change="updateData"
                  />
                  Yes
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.socialManagement" 
                    value="no"
                    @change="updateData"
                  />
                  No
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.socialManagement" 
                    value="uncertain"
                    @change="updateData"
                  />
                  Uncertain
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.socialManagement" 
                    value="skip"
                    @change="updateData"
                  />
                  Skip
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.socialManagement" 
                    value="na"
                    @change="updateData"
                  />
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="socialManagementComments">Comments</label>
            <textarea 
              id="socialManagementComments"
              v-model="formData.socialManagementComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>
        </div>
      </section>

      <!-- Economic Prefeasibility -->
      <section class="form-section">
        <div class="section-header">
          <h3>Section D: Economic Prefeasibility</h3>
          <span class="section-description">(Optional)</span>
        </div>
        
        <div class="form-grid">
          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">1.Is the economic rate of return (ERR) likely to be higher than the threshold ERR requirements of the government?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.economicRateOfReturn" 
                    value="yes"
                    @change="updateData"
                  />
                  Yes
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.economicRateOfReturn" 
                    value="no"
                    @change="updateData"
                  />
                  No
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.economicRateOfReturn" 
                    value="uncertain"
                    @change="updateData"
                  />
                  Uncertain
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.economicRateOfReturn" 
                    value="skip"
                    @change="updateData"
                  />
                  Skip
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.economicRateOfReturn" 
                    value="na"
                    @change="updateData"
                  />
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="economicRateOfReturnComments">Comments</label>
            <textarea 
              id="economicRateOfReturnComments"
              v-model="formData.economicRateOfReturnComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">2.Will communities within the area of influence of the project be able to share direct or indirect economic benefits from the project?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.communityBenefits" 
                    value="yes"
                    @change="updateData"
                  />
                  Yes
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.communityBenefits" 
                    value="no"
                    @change="updateData"
                  />
                  No
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.communityBenefits" 
                    value="uncertain"
                    @change="updateData"
                  />
                  Uncertain
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.communityBenefits" 
                    value="skip"
                    @change="updateData"
                  />
                  Skip
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.communityBenefits" 
                    value="na"
                    @change="updateData"
                  />
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="communityBenefitsComments">Comments</label>
            <textarea 
              id="communityBenefitsComments"
              v-model="formData.communityBenefitsComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>
        </div>
      </section>

      <!-- Financial Prefeasibility -->
      <section class="form-section">
        <div class="section-header">
          <h3>Section E: Financial Prefeasibility</h3>
          <span class="section-description">(Optional)</span>
        </div>
        
        <div class="form-grid">
          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">1.Is there a preliminary financial analysis based on assessment of the net present value (NPV) or internal rate of return (IRR) of the project's cash flows?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.preliminaryFinancialAnalysis" 
                    value="yes"
                    @change="updateData"
                  />
                  Yes
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.preliminaryFinancialAnalysis" 
                    value="no"
                    @change="updateData"
                  />
                  No
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.preliminaryFinancialAnalysis" 
                    value="uncertain"
                    @change="updateData"
                  />
                  Uncertain
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.preliminaryFinancialAnalysis" 
                    value="skip"
                    @change="updateData"
                  />
                  Skip
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.preliminaryFinancialAnalysis" 
                    value="na"
                    @change="updateData"
                  />
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="preliminaryFinancialAnalysisComments">Comments</label>
            <textarea 
              id="preliminaryFinancialAnalysisComments"
              v-model="formData.preliminaryFinancialAnalysisComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">2.Are the user charge assumptions backed by user surveys or consistent with the tariff in similar projects?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.userChargeAssumptions" value="yes" :disabled="viewMode" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.userChargeAssumptions" value="no" :disabled="viewMode" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.userChargeAssumptions" value="uncertain" :disabled="viewMode" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.userChargeAssumptions" value="skip" :disabled="viewMode" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.userChargeAssumptions" value="na" :disabled="viewMode" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="userChargeAssumptionsComments">Comments</label>
            <textarea 
              id="userChargeAssumptionsComments"
              v-model="formData.userChargeAssumptionsComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">3.Are the demand or volume projections backed by surveys or demand forecasting models using reliable historical data?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.demandProjections" value="yes" :disabled="viewMode" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.demandProjections" value="no" :disabled="viewMode" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.demandProjections" value="uncertain" :disabled="viewMode" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.demandProjections" value="skip" :disabled="viewMode" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.demandProjections" value="na" :disabled="viewMode" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="demandProjectionsComments">Comments</label>
            <textarea 
              id="demandProjectionsComments"
              v-model="formData.demandProjectionsComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">4.Are the financing assumptions comparable to similar projects? Such as the debt-to-equity ratio, interest rate and tenure of debt, and cost of equity?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.financingAssumptions" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.financingAssumptions" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.financingAssumptions" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.financingAssumptions" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.financingAssumptions" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="financingAssumptionsComments">Comments</label>
            <textarea 
              id="financingAssumptionsComments"
              v-model="formData.financingAssumptionsComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">5.Is the project likely to be financially viable?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.financialViability" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.financialViability" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.financialViability" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.financialViability" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.financialViability" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="financialViabilityComments">Comments</label>
            <textarea 
              id="financialViabilityComments"
              v-model="formData.financialViabilityComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>
        </div>

        <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">6.Is the project IRR (post-tax) greater than the threshold rate?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.financialViability1" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.financialViability1" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.financialViability1" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.financialViability1" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.financialViability1" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="financialViability1Comments">Comments</label>
            <textarea 
              id="financialViability1Comments"
              v-model="formData.financialViability1Comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>
          
        <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">7.Will the project IRR (post-tax) remain greater than the threshold rate in the stress (or low) case scenario?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.financialViability2" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.financialViability2" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.financialViability2" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.financialViability2" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.financialViability2" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="financialViability2Comments">Comments</label>
            <textarea 
              id="financialViability2Comments"
              v-model="formData.financialViability2Comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>
          
        <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">8.Is the project's minimum DSCR greater than the threshold ratio for the duration of the loan?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.financialViability3" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.financialViability3" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.financialViability3" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.financialViability3" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.financialViability3" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="financialViability3Comments">Comments</label>
            <textarea 
              id="financialViability3Comments"
              v-model="formData.financialViability3Comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>
          
        <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">9.Will the project's minimum DSCR remain greater than the threshold ratio for the duration of the loan, in the stress (or low) case scenario?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input type="radio" v-model="formData.financialViability4" value="yes" @change="updateData"/>
                  Yes
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.financialViability4" value="no" @change="updateData"/>
                  No
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.financialViability4" value="uncertain" @change="updateData"/>
                  Uncertain
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.financialViability4" value="skip" @change="updateData"/>
                  Skip
                </label>
                <label class="radio-option">
                  <input type="radio" v-model="formData.financialViability4" value="na" @change="updateData"/>
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="financialViability4Comments">Comments</label>
            <textarea 
              id="financialViability4Comments"
              v-model="formData.financialViability4Comments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>
      </section>

      <!-- Legal Prefeasibility -->
      <section class="form-section">
        <div class="section-header">
          <h3>Section F: Legal Prefeasibility</h3>
          <span class="section-description">(Optional)</span>
        </div>
        
        <div class="form-grid">
          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">1.Is there a framework that provides a basis for charging tariffs and are there clear methodologies for tariff setting and periodic reviews?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.tariffFramework" 
                    value="yes"
                    @change="updateData"
                  />
                  Yes
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.tariffFramework" 
                    value="no"
                    @change="updateData"
                  />
                  No
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.tariffFramework" 
                    value="uncertain"
                    @change="updateData"
                  />
                  Uncertain
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.tariffFramework" 
                    value="skip"
                    @change="updateData"
                  />
                  Skip
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.tariffFramework" 
                    value="na"
                    @change="updateData"
                  />
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="tariffFrameworkComments">Comments</label>
            <textarea 
              id="tariffFrameworkComments"
              v-model="formData.tariffFrameworkComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">2.Does the law confer enforceable rights such as, rights of substitution, step-in rights or other applicable remedies that enable the lenders to recover their outstanding loan amounts?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.enforceableRights" 
                    value="yes"
                    @change="updateData"
                  />
                  Yes
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.enforceableRights" 
                    value="no"
                    @change="updateData"
                  />
                  No
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.enforceableRights" 
                    value="uncertain"
                    @change="updateData"
                  />
                  Uncertain
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.enforceableRights" 
                    value="skip"
                    @change="updateData"
                  />
                  Skip
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.enforceableRights" 
                    value="na"
                    @change="updateData"
                  />
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="enforceableRightsComments">Comments</label>
            <textarea 
              id="enforceableRightsComments"
              v-model="formData.enforceableRightsComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">3.Are there any restrictions on foreign exchange or capital movements that may limit the project's access to finance?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.foreignExchangeRestrictions" 
                    value="yes"
                    @change="updateData"
                  />
                  Yes
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.foreignExchangeRestrictions" 
                    value="no"
                    @change="updateData"
                  />
                  No
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.foreignExchangeRestrictions" 
                    value="uncertain"
                    @change="updateData"
                  />
                  Uncertain
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.foreignExchangeRestrictions" 
                    value="skip"
                    @change="updateData"
                  />
                  Skip
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.foreignExchangeRestrictions" 
                    value="na"
                    @change="updateData"
                  />
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="foreignExchangeRestrictionsComments">Comments</label>
            <textarea 
              id="foreignExchangeRestrictionsComments"
              v-model="formData.foreignExchangeRestrictionsComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>

          <div class="form-group full-width">
            <label class="checkbox-label">
              <span class="checkbox-text">4.If applicable, Is there a plan to address legal barriers through appropriate executive action or legislative reforms?</span>
              <div class="radio-group">
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.legalBarriersPlan" 
                    value="yes"
                    @change="updateData"
                  />
                  Yes
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.legalBarriersPlan" 
                    value="no"
                    @change="updateData"
                  />
                  No
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.legalBarriersPlan" 
                    value="uncertain"
                    @change="updateData"
                  />
                  Uncertain
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.legalBarriersPlan" 
                    value="skip"
                    @change="updateData"
                  />
                  Skip
                </label>
                <label class="radio-option">
                  <input 
                    type="radio" 
                    v-model="formData.legalBarriersPlan" 
                    value="na"
                    @change="updateData"
                  />
                  N/A
                </label>
              </div>
            </label>
          </div>

          <div class="form-group full-width">
            <label for="legalBarriersPlanComments">Comments</label>
            <textarea 
              id="legalBarriersPlanComments"
              v-model="formData.legalBarriersPlanComments"
              rows="4"
              placeholder="Provide additional details or explanations"
              @input="updateData"
            ></textarea>
          </div>
        </div>
      </section>
      

    </form>
  </div>
</template>

<script>
export default {
  name: 'PreliminaryFeasibilityTab',
  props: {
    projectData: {
      type: Object,
      default: () => ({})
    },
    viewMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {
        provenTechnology: '',
        provenTechnologyComments: '',
        comparableScope: '',
        comparableScopeComments: '',
        costEstimates: '',
        costEstimatesComments: '',
        lifeCycleCosts: '',
        lifeCycleCostsComments: '',
        siteSuitability: '',
        siteSuitabilityComments: '',
        siteAccessibility: '',
        siteAccessibilityComments: '',
        technicalSkills: '',
        technicalSkillsComments: '',
        environmentalAnalysis: '',
        environmentalAnalysisComments: '',
        environmentalImpact: '',
        environmentalImpactComments: '',
        environmentalManagement: '',
        environmentalManagementComments: '',
        socialAnalysis: '',
        socialAnalysisComments: '',
        socialImpact: '',
        socialImpactComments: '',
        socialSustainability: '',
        socialSustainabilityComments: '',
        socialManagement: '',
        socialManagementComments: '',
        economicRateOfReturn: '',
        economicRateOfReturnComments: '',
        communityBenefits: '',
        communityBenefitsComments: '',
        preliminaryFinancialAnalysis: '',
        preliminaryFinancialAnalysisComments: '',
        userChargeAssumptions: '',
        userChargeAssumptionsComments: '',
        demandProjections: '',
        demandProjectionsComments: '',
        financingAssumptions: '',
        financingAssumptionsComments: '',
        financialViability: '',
        financialViabilityComments: '',
        financialViability1: '',
        financialViability1Comments: '',
        financialViability3: '',
        financialViability3Comments: '',
        financialViability2: '',
        financialViability2Comments: '',
        financialViability4: '',
        financialViability4Comments: '',
        tariffFramework: '',
        tariffFrameworkComments: '',
        enforceableRights: '',
        enforceableRightsComments: '',
        foreignExchangeRestrictions: '',
        foreignExchangeRestrictionsComments: '',
        legalBarriersPlan: '',
        legalBarriersPlanComments: ''
      },
      errors: {},
      showValidation: false
    }
  },
  computed: {
    isValid() {
      return this.validateForm().isValid
    },
    isSectionComplete() {
      // Section is complete when all questions are answered
      return this.formData.provenTechnology && 
             this.formData.comparableScope &&
             this.formData.costEstimates &&
             this.formData.lifeCycleCosts &&
             this.formData.siteSuitability &&
             this.formData.siteAccessibility &&
             this.formData.technicalSkills &&
             this.formData.environmentalAnalysis &&
             this.formData.environmentalImpact &&
             this.formData.environmentalManagement &&
             this.formData.socialAnalysis &&
             this.formData.socialImpact &&
             this.formData.socialSustainability &&
             this.formData.socialManagement &&
             this.formData.economicRateOfReturn &&
             this.formData.communityBenefits &&
             this.formData.preliminaryFinancialAnalysis &&
             this.formData.userChargeAssumptions &&
             this.formData.demandProjections &&
             this.formData.financingAssumptions &&
             this.formData.financialViability &&
             this.formData.tariffFramework &&
             this.formData.enforceableRights &&
             this.formData.foreignExchangeRestrictions &&
             this.formData.legalBarriersPlan
    }
  },
  watch: {
    projectData: {
      handler(newData) {
        if (newData && Object.keys(newData).length > 0) {
          this.formData = { ...this.formData, ...newData }
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    updateData() {
      this.$emit('update', this.formData)
      this.validateForm()
    },
    validateForm() {
      this.errors = {}
      let isValid = true

      this.showValidation = true
      this.$emit('validate', isValid)
      
      return { isValid, errors: this.errors }
    },
    validateAndSubmit() {
      this.validateForm()
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.validateForm()
    })
  }
}
</script>

<style scoped>.preliminary-feasibility-tab {
  max-width: 1000px;
  margin: 0 auto;
}

.tab-header {
  text-align: center;
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 2px solid #e9ecef;
}

.tab-header h2 {
  font-size: 2rem;
  color: #333;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.tab-description {
  color: #666;
  font-size: 1.1rem;
  line-height: 1.6;
  max-width: 600px;
  margin: 0 auto;
}

.form-section {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 2rem;
  border-left: 4px solid #00338d;
}

.section-header {
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #dee2e6;
}

.section-header h3 {
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.section-description {
  color: #666;
  font-size: 0.95rem;
  font-style: italic;
}

.validation-status {
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #dee2e6;
}

.validation-success {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: #28a745;
  font-weight: 600;
}

.validation-success svg {
  flex-shrink: 0;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-group label {
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
  display: block;
}

.form-group textarea {
  padding: 0.75rem;
  border: 2px solid #e0e6ed;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s, box-shadow 0.3s;
  background: white;
  resize: vertical;
  min-height: 100px;
  font-family: inherit;
}

.form-group textarea:focus {
  outline: none;
  border-color: #00338d;
  box-shadow: 0 0 0 3px rgba(0, 51, 141, 0.1);
}

.checkbox-label {
  display: block !important;
}

.checkbox-text {
  font-weight: 600;
  color: #333;
  margin-bottom: 1rem;
  display: block;
}

.radio-group {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: 0.75rem;
  margin-top: 0.75rem;
  align-items: stretch;
}

.radio-group.yes-no {
  grid-template-columns: repeat(2, minmax(80px, 120px));
  justify-content: start;
}

.radio-option {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-weight: 500;
  padding: 0.75rem 1rem;
  min-height: 40px;
  position: relative;
  transition: all 0.2s ease;
  border-radius: 8px;
  border: 2px solid #d1d5db;
  background: #ffffff;
  color: #374151;
  text-align: center;
}

.radio-option input[type="radio"] {
  display: none;
}

.radio-option:has(input[type="radio"]:checked) {
  background: #00338d;
  border-color: #00338d;
  color: white;
  font-weight: 600;
  box-shadow: 0 0 0 2px rgba(0, 51, 141, 0.2);
}

/* Fallback for browsers that don't support :has() */
.radio-option.selected {
  background: #00338d;
  border-color: #00338d;
  color: white;
  font-weight: 600;
  box-shadow: 0 0 0 2px rgba(0, 51, 141, 0.2);
}

.radio-option.selected:hover {
  background: #002966;
  border-color: #002966;
  color: white;
}

.radio-option:hover {
  background-color: #e8f0fe;
  border-color: #00338d;
  color: #00338d;
}

.radio-option:hover:has(input[type="radio"]:checked) {
  background: #002966;
  border-color: #002966;
  color: white;
}

.radio-option:has(input[type="radio"]:focus) {
  border-color: #00338d;
  box-shadow: 0 0 0 3px rgba(0, 51, 141, 0.1);
  outline: none;
}

.radio-option:has(input[type="radio"]:focus-visible) {
  outline: 2px solid #00338d;
  outline-offset: 2px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
  
  .radio-group {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75rem;
    margin-top: 0.5rem;
  }
  
  .radio-option {
    padding: 0.75rem 0.75rem;
    min-height: 44px;
    font-size: 0.95rem;
  }
  
  .form-section {
    padding: 1rem;
  }
}

@media (max-width: 480px) {
  .radio-group {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
  
  .radio-option {
    padding: 1rem 0.75rem;
    min-height: 48px;
    font-size: 0.9rem;
  }
}
</style>